<template></template>
<script>
/**
 * The user will be sent here from the link in the verify account e-mail address.
 * This will simply make an ajax call to verify and then redirect the user back to the login screen
 */
import { mapActions } from 'vuex';
export default {
    name: 'VerifyCallback',
    mounted() {
        this.verify();
    },
    methods: {
        ...mapActions({
            verify: 'Auth/emailVerify'
        })
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/stages/VerifyCallback.vue